/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightUpIcon20Solid = forwardRef('ArrowDCornerRightUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M18.884 6.366a1.25 1.25 0 0 1-1.768 1.768L13.75 4.768V14A3.75 3.75 0 0 1 10 17.75H2.5a1.25 1.25 0 1 1 0-2.5H10c.69 0 1.25-.56 1.25-1.25V4.768L7.884 8.134a1.25 1.25 0 1 1-1.768-1.768l4.44-4.44a2.75 2.75 0 0 1 3.889 0l4.439 4.44Z" })));
});
